"use client";

import { useEffect, useRef } from "react";
import "@/modules/web/styles/termsOfService.css";

type TermsOfServiceContentProps = {
  html: string;
};

export default function TermsOfServiceContent({
  html,
}: TermsOfServiceContentProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    // Open first accordion item by default
    const firstHeader = container.querySelector(
      ".card-header",
    ) as HTMLElement | null;
    if (firstHeader) {
      firstHeader.classList.add("active");
      firstHeader.nextElementSibling?.classList.add("open");
    }

    const handleClick = (event: Event) => {
      const target = event.target as HTMLElement | null;
      const header = target?.closest(".card-header") as HTMLElement | null;

      if (!header || !container.contains(header)) {
        return;
      }

      const isCurrentlyActive = header.classList.contains("active");

      // Close all accordion items in container
      const allHeaders = container.querySelectorAll(".card-header");
      allHeaders.forEach((h) => {
        h.classList.remove("active");
        h.nextElementSibling?.classList.remove("open");
      });

      // If it was not active before, open it
      if (!isCurrentlyActive) {
        header.classList.add("active");
        header.nextElementSibling?.classList.add("open");
      }
    };

    container.addEventListener("click", handleClick);

    return () => {
      container.removeEventListener("click", handleClick);
    };
  }, [html]);

  return (
    <div className="terms-of-service-page mx-auto max-w-5xl">
      <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
